module.exports = __webpack_public_path__ + "img/Gallery_2_16.0605961f.jpeg";